import { SET_MENU } from "../constants/menuConstant";

export const setMenuActive = (name) => async (dispatch) => {
  dispatch({ type: SET_MENU, payload: name });
};
